import { render } from "./my-work.vue?vue&type=template&id=1d4f12aa&scoped=true&ts=true"
import script from "./my-work.vue?vue&type=script&lang=ts"
export * from "./my-work.vue?vue&type=script&lang=ts"

import "./my-work.vue?vue&type=style&index=0&id=1d4f12aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f12aa"]])

export default __exports__